/* eslint-disable import/no-cycle */

import ToyHttp2 from '@toy/http2';
import { ElMessage } from 'element-plus';
import { API_BASE, SYSTEM_ENUM } from '@/core/http/env';
import { CURRENT_CLIENT_CODE, SSO_SYSTEM_CODE } from '@/constant';
import { useAccountStore } from '@/store/account';

const http = new ToyHttp2<SYSTEM_ENUM>({
  requestDefaultConfig: {
    server: SYSTEM_ENUM.TG_FASHION_DESIGN_API,
  },
});

http.setDomain(API_BASE);
http.setHeader({
  'System-Code': SSO_SYSTEM_CODE,
  'Client-Code': CURRENT_CLIENT_CODE,
});

http.setForbiddenCallback(async () => {
  ElMessage.error('无权限访问该接口');
});

http.setUnauthorizedCallback(async () => {
  console.log('401');
  ElMessage.error('登录已过期，请重新登录');
  await useAccountStore().login();
});

export default http;
